import React from 'react';
import styles from './agreement_list.module.scss';

/**
 * Indicates that there is a SaleSys order associated with this agreement.
 */
export const AgreementOrderIndicator: React.FC = () => (
  <svg className={styles.orderIndicator} xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
    <rect width="153" height="449" rx="51" transform="translate(468.966 52.554) rotate(45)" fill="#1565c0" />
    <rect width="153" height="521" rx="51" transform="translate(509.966 285.554) rotate(45)" fill="#1565c0" />
    <rect width="153" height="577" rx="51" transform="translate(775.551 306.968) rotate(45)" fill="#1565c0" />
    <rect width="153" height="306" rx="51" transform="translate(719.966 658.554) rotate(45)" fill="#1565c0" />
  </svg>
)